import { render, staticRenderFns } from "./selectTeamMember.vue?vue&type=template&id=2844949a&"
import script from "./selectTeamMember.vue?vue&type=script&lang=ts&"
export * from "./selectTeamMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports